module.exports = __webpack_public_path__ + "img/4.61f1316d.jpg";